import React, { useEffect, useState } from "react";
import style from "../../administration/UserManagement/AirlineRepModal/airlineRepModal.module.css";
import { withStyles, createStyles, Theme, DialogTitle, IconButton, Dialog, DialogContent } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import commonStyles from '../../common/common.module.css';
import PaymentsPO from '../../../models/PaymentsPO';
import { formatCurrency } from '../../../utils/currencyFormatter';
import cartStyles from '../../cart/cart.module.css';
import PaymentPageContainer from '../../common/paymentPageCommon/PaymentPageContainer';
import { UserRoleType } from '../../../models/User';
import cartRemote from '../../../api/cartRemote';

interface ConvertPoModalProps {
  modalOpen: boolean;
  handleClose: () => void;
  proceed: (paymentDetails?: any) => void;
  payments: PaymentsPO | undefined;
  orderNumber: string;
  history: any;
}

const styles = (theme: Theme) => createStyles({});

const ConvertPoModal = (props: ConvertPoModalProps) => {
  const [goCharges, setGoCharges] = useState<any>(null);

  useEffect(() => {
    if (props.modalOpen && props.orderNumber) {
      cartRemote.getGoCharges(props.orderNumber).then(res => {
        console.log('🚀 ~ ConvertPoModal ~ res:', res)
        if (res.result) setGoCharges(res.result);
      });
    }
  }, [props.modalOpen, props.orderNumber]);

  const groupedCharges = React.useMemo(() => {
    if (!goCharges || !goCharges.charges) return null;
    const groups: Record<string, any[]> = {};
    goCharges.charges.forEach((charge: any) => {
      const awb = `${charge.awb_code}-${charge.awb_number}`;
      if (!groups[awb]) groups[awb] = [];
      groups[awb].push(charge);
    });
    return groups;
  }, [goCharges]);

  return (
    <Dialog open={props.modalOpen} onClose={props.handleClose} maxWidth={"sm"} fullWidth={true}>
      <DialogTitle id="form-dialog-title">
        <div className={commonStyles.dialogTitle}>
          <div className={commonStyles.name}>Convert GO Order to PO</div>
          <IconButton aria-label="Close" className={style.close} onClick={props.handleClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        { props.payments ? (
          <div>
            <p className={style.feeText} style={{ marginBottom: 20 }}>
              You are about to convert your GO Order to a PO (Pickup Order). <br/> Here is the payment summary for this PO:
            </p>
            <div className={ `${ commonStyles.wrapper } ${ commonStyles.p4 }` } style={{ marginBottom: 20, backgroundColor: '#f9f9f9', border: '1px solid #e0e0e0', borderRadius: 4 }}>
              
              {groupedCharges && Object.keys(groupedCharges).map((awb, idx) => (
                <div key={idx} style={{ marginBottom: 15, padding: '10px 10px 0 10px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: 5, borderBottom: '1px solid #d4d4d4', marginBottom: 8 }}>
                    <span className={ cartStyles.pot } style={{ fontWeight: 'bold', fontSize: '1rem', color: '#333' }}>AWB: {awb}</span>
                  </div>
                  {groupedCharges[awb].map((charge: any, cIdx: number) => (
                    <div key={cIdx} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5, paddingLeft: 10 }}>
                      <span className={ cartStyles.pot } style={{ textTransform: 'capitalize', color: '#666' }}>
                        {charge.service_name ? charge.service_name.replace(/_/g, ' ') : 'Accrued Charge'}
                      </span>
                      <span className={ cartStyles.pod } style={{ color: '#555' }}>{formatCurrency(Number(charge.amount_mili) / 1000000, 2, '$')}</span>
                    </div>
                  ))}
                </div>
              ))}

              <hr style={{ borderTop: '1px solid #ccc', margin: '15px 0' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 10px 10px 10px' }}>
                <span className={ cartStyles.pot } style={{ fontSize: '1.05em', fontWeight: 'bold' }}>Total Amount Due:</span>
                <span className={ cartStyles.pod } style={{ fontSize: '1.15em', fontWeight: 'bold', color: 'var(--primaryblue)' }}>{ formatCurrency(goCharges && goCharges.total_amount_mili ? Number(goCharges.total_amount_mili) / 1000000 : props.payments.totalDue, 2, '$') }</span>
              </div>
            </div>
            
            <PaymentPageContainer 
              userRole={UserRoleType.FORWARDER }
              history={props.history} 
              orderNumber={ props.orderNumber }
              closeModal={ props.handleClose }
              overrideAmountDue={goCharges && goCharges.total_amount_mili ? Number(goCharges.total_amount_mili) / 1000000 : props.payments.totalDue}
              overrideCartItemsLength={1}
              alternativePaymentOnly={true}
              customHandlePayment={(paymentOther: string, paymentType: string, stripePaymentMethodId?: string) => {
                props.proceed({ paymentInfo: paymentOther, paymentType, stripePaymentMethodId });
              }}
            />
          </div>
        ) : (
          <p>Converting order and loading payment details...</p>
        )}
      </DialogContent>
    </Dialog>
  );
};
export default withStyles(styles)(ConvertPoModal);
